import $storage from '@/utils/storage/storage.js'
const drawer = !1
const isDark = $storage.get('isDark') || !1
const drawerMini = $storage.get('drawerMini') || !1
const baseURL = window.location.origin
const state = {
  app: {
    baseURL,
  },
  site: {},
  drawer,
  isDark: !1,
  drawerMini
}

const actions = {
  getSite ({ commit }, site) {
    commit('GET_SITE', site)
    commit('GET_DARK', isDark)
    return site
  },
  toggleDrawer: ({ commit }) => {
    commit('TOGGLE_DRAWER')
  },
  toggleDrawerMini: ({ commit }) => {
    commit('TOGGLE_DRAWER_MINI')
  },
  toggleDark ({ commit }, isDark) {
    commit('TOGGLE_DARK', isDark)
  },
  async sendEmail ({ }, form) {
    return axios.update('/email/send', form)
  }
}

const mutations = {
  GET_SITE: (state, site) => {
    state.site = site
  },
  TOGGLE_DRAWER: (state) => {
    state.drawer = !state.drawer
  },
  TOGGLE_DRAWER_MINI: (state) => {
    state.drawerMini = !state.drawerMini;
    $storage.set("drawerMini", state.drawerMini);
  },
  TOGGLE_DARK: (state, isDark) => {
    state.isDark = isDark
    $storage.set('isDark', state.isDark)
  },
  GET_DARK: (state) => {
    state.isDark = $storage.get('isDark') || !1
  }
}

const getters = {
  site: state => state.site,
  app: state => state.app,
  drawer: state => state.drawer,
  drawerMini: state => state.drawerMini,
  isDark: state => state.isDark,
}

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state
}
